import { BoltDriver } from "@mirage/bolt/driver";
import { tagged } from "@mirage/service-logging";

import type { dash_notification_plat } from "@dropbox/api-v2-client";

const logger = tagged("notifications-bolt");

// Notifications are sent on a single channel, so we don't need to support multiple channels
export class NotificationsBolt {
  private readonly boltDriver: BoltDriver;

  public constructor(
    boltOrigin: string,
    isDev: boolean,
    isTest: boolean,
    private readonly performSync: () => Promise<void>,
  ) {
    this.boltDriver = new BoltDriver(
      boltOrigin,
      isDev ? (s) => logger.debug("[Notifications Bolt Driver]", s) : () => {},
      isTest,
    );
  }

  public async subscribe(boltData: dash_notification_plat.BoltData) {
    this.setBoltData(boltData);

    // Only need to startListening once
    if (this.boltDriver.started) {
      return;
    }
    this.boltDriver.startListening(
      () => this.performSync(),
      () => this.performSync(),
    );
  }

  public setBoltData(boltData: dash_notification_plat.BoltData) {
    const channelStates = [
      {
        channel_id: {
          app_id: "dash_user_notification",
          unique_id: boltData.bolt_unique_id ?? "",
        },
        revision: String(boltData.revision ?? 0),
        token: boltData.bolt_token ?? "",
      },
    ];
    this.boltDriver.setChannelStates(channelStates);
  }

  public stop() {
    this.boltDriver.stopListening();
  }
}
